// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2LMtj","errorLogs":"styles_errorLogs__pMZ84"};